import React, {useState} from "react";
import { ChevronRightCircle } from 'lucide-react';
import "./roadmap.scss";

export default function Roadmap(){

  const [header, setHeader] = useState("Test prep counselling");
  const [description, setDescription] = useState("Connect with our IELTS experts and get all your IELTS preparation doubts cleared. Our expert tutors will assess your profile, course requirement and target score in detail and guide you further in the process. They will explain to you the leverage live process and how it focuses on helping you achieve your target band/score");
  const [imagename, setImagename] = useState("/assets/rm-Icon.png");
  const [isVisible, setVisibility] = useState({
   visibility1: false,
   visibility2: false,
   visibility3: false,
   visibility4: false,
   visibility5: false,
   visibility6: false,
 });


  const handleButton1Click = () => {
   setHeader("Test prep counselling");
   setDescription("Connect with our IELTS experts and get all your IELTS preparation doubts cleared. Our expert tutors will assess your profile, course requirement and target score in detail and guide you further in the process. They will explain to you the leverage live process and how it focuses on helping you achieve your target band/score");
   setImagename("/assets/rm-Icon.png");
   setVisibility({
    visibility1: true,
    visibility2: false,
    visibility3: false,
    visibility4: false,
    visibility5: false,
    visibility6: false, });
 };

  const handleButton2Click = () => {
   setHeader("Free Demo Class");
   setDescription("(2) Connect with our IELTS experts and get all your IELTS preparation doubts cleared. Our expert tutors will assess your profile, course requirement and target score in detail and guide you further in the process. They will explain to you the leverage live process and how it focuses on helping you achieve your target band/score");
   setImagename("/assets/rm-Icon.png");
   setVisibility({
     visibility1: false,
     visibility2: true,
     visibility3: false,
     visibility4: false,
     visibility5: false,
     visibility6: false, });
 };

  const handleButton3Click = () => {
   setHeader("Onboarding");
   setDescription("(3) Connect with our IELTS experts and get all your IELTS preparation doubts cleared. Our expert tutors will assess your profile, course requirement and target score in detail and guide you further in the process. They will explain to you the leverage live process and how it focuses on helping you achieve your target band/score");
   setImagename("/assets/rm-Icon.png");
   setVisibility({
     visibility1: false,
     visibility2: false,
     visibility3: true,
     visibility4: false,
     visibility5: false,
     visibility6: false, });
 };


  const handleButton4Click = () => {
   setHeader("Personalised Student Dashboard");
   setDescription("(4) Connect with our IELTS experts and get all your IELTS preparation doubts cleared. Our expert tutors will assess your profile, course requirement and target score in detail and guide you further in the process. They will explain to you the leverage live process and how it focuses on helping you achieve your target band/score");
   setImagename("/assets/rm-Icon.png");
   setVisibility({
     visibility1: false,
     visibility2: false,
     visibility3: false,
     visibility4: true,
     visibility5: false,
     visibility6: false, });
 };

  const handleButton5Click = () => {
   setHeader("Live IELTS classes and Parctice");
   setDescription("(5) Connect with our IELTS experts and get all your IELTS preparation doubts cleared. Our expert tutors will assess your profile, course requirement and target score in detail and guide you further in the process. They will explain to you the leverage live process and how it focuses on helping you achieve your target band/score");
   setImagename("/assets/rm-Icon.png");
   setVisibility({
     visibility1: false,
     visibility2: false,
     visibility3: false,
     visibility4: false,
     visibility5: true,
     visibility6: false,});
 };

  const handleButton6Click = () => {
   setHeader("Free Servicing for Exam Slot Registration");
   setDescription("(6) Connect with our IELTS experts and get all your IELTS preparation doubts cleared. Our expert tutors will assess your profile, course requirement and target score in detail and guide you further in the process. They will explain to you the leverage live process and how it focuses on helping you achieve your target band/score");
   setImagename("/assets/rm-Icon.png");
   setVisibility({
     visibility1: false,
     visibility2: false,
     visibility3: false,
     visibility4: false,
     visibility5: false,
     visibility6: true, });
 };

  return(
  <div className="roadmap" id="roadmap">
   <div className="roadmap-header">Roadmap For Your IELTS Success  Journey</div>
   <div className="roadmap-subheading">Start Your step by step IELTS test prep journey with our highly certified IELTS tutors and let our personalised process help you achieve a 7+ IELTS Band</div>
   <div className="outer-roadmap">
   <div className="roadmap-main">
    <div className="points">
       <div className="ind-point"><div className={`fflex ${isVisible.visibility1 ? 'visible' : ''}`} onClick={handleButton1Click}> <ChevronRightCircle className="point-btn"/><div className="point-1">Test Prep Counselling</div></div>{isVisible.visibility1 && <div className="line visibility1"></div>}</div>
       <div className="ind-point"><div className={`fflex ${isVisible.visibility2 ? 'visible' : ''}`} onClick={handleButton2Click}><ChevronRightCircle className="point-btn"/><div className="point-1">Free Demo Class</div></div>{isVisible.visibility2 && <div className="line visibility2"></div>}</div>
       <div className="ind-point"><div className={`fflex ${isVisible.visibility3 ? 'visible' : ''}`} onClick={handleButton3Click}><ChevronRightCircle className="point-btn"/><div className="point-1">Onboarding</div></div>{isVisible.visibility3 &&<div className="line visibility3"></div>}</div>
       <div className="ind-point"><div className={`fflex ${isVisible.visibility4 ? 'visible' : ''}`} onClick={handleButton4Click}><ChevronRightCircle className="point-btn"/><div className="point-1">Personalised Student Dashboard</div></div>{isVisible.visibility4 && <div className="line visibility4"></div>}</div>
       <div className="ind-point"><div className={`fflex ${isVisible.visibility5 ? 'visible' : ''}`} onClick={handleButton5Click}><ChevronRightCircle className="point-btn"/><div className="point-1">Live IELTS Classes and Practice</div></div>{isVisible.visibility5 && <div className="line visibility5"></div>}</div>
       <div className="ind-point"><div className={`fflex ${isVisible.visibility6 ? 'visible' : ''}`} onClick={handleButton6Click}><ChevronRightCircle className="point-btn"/><div className="point-1">Free Servicing for Exam Slot Registration</div></div>{isVisible.visibility6 && <div className="line visibility6"></div>}</div>
    </div>
    <div className="roadmap-description" id="roadmap-description">
    <div className="desc-card">
       <img src={imagename} alt="image" className="desc-img"/>
       <div className="desc-card-header">{header}</div>
       <div className="desc-card-desc">{description}</div>
    </div>
    </div>
   </div>
   </div>
  </div>
  )
}
